module.exports = "/_next/static/images/icon-no-1-0956782f.png";